import { useEffect, useState } from "react";
import NavigationLayout from "../../navigation/navigationLayout";
import FooterLayout from "../../footer/footerLayout";
import JobDetails from "./jobDetails";
import FileNotFound from "../../errors/fileNotFound";
import FileIcon from '../../../assets/icons/file.svg';
import { useTranslation } from "react-i18next";

const JobDetailsLayout = ({
    job
}) => {
    const {t} = useTranslation();

    const [data, setData] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        if(job){
            import(`../../../assets/data/careers/${job}.json`)
            .then((module) => setData(module.default))
            .catch((err) => setError(true));
        }
    }, [job]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            {
                data
                ?
                <JobDetails data={data}/>
                :
                <>
                    {
                        error
                        ?
                        <FileNotFound 
                            icon={FileIcon}
                            description={t('careers.jobOpenings.jobMissing')}
                            actionText={t('careers.jobOpenings.vacancies')}
                            navigateLink='/careers'
                        />
                        :
                        <></>
                    }
                </>
            }

            <FooterLayout />
        </>
    );
}

export default JobDetailsLayout;